"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBrush = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M2.613 8.53a2.092 2.092 0 000 2.958l4.437 4.437 8.875-8.875-4.438-4.437a2.092 2.092 0 00-2.958 0L7.356 3.785 8.71 5.137a1.046 1.046 0 01-1.48 1.48L5.877 5.264 4.462 6.68l3.634 3.634a1.046 1.046 0 01-1.48 1.48L2.984 8.158l-.37.37zM8.454 17.33l8.875-8.874.694.694c.678.679.808 1.732.314 2.556l-1.378 2.297 4.427 4.427a2.092 2.092 0 01-2.958 2.958l-4.427-4.427-2.298 1.379a2.092 2.092 0 01-2.555-.315l-.694-.694z' }))); };
exports.default = SvgBrush;
//# sourceMappingURL=Brush.js.map